<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="600px">
    <v-card v-if="clinic">
      <v-card-title>
        <span class="headline">Detalles de la Clínica</span>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" class="cursor-pointer">mdi-close</v-icon>
      </v-card-title>

      <v-card-text>
        <!-- Información General -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-chip :color="getTypeColor(clinic.type)" text-color="white" large class="mb-2">
              {{ getTypeLabel(clinic.type) }}
            </v-chip>
          </v-col>
        </v-row>

        <!-- Profesor -->
        <v-row class="mb-3">
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold grey--text">Profesor</div>
            <div class="headline">{{ teacherName }}</div>
          </v-col>
        </v-row>

        <!-- Fecha y Hora -->
        <v-row>
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Fecha</div>
            <div>{{ formatDate(clinic.date) }}</div>
          </v-col>
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Hora</div>
            <div>{{ clinic.time }}</div>
          </v-col>
        </v-row>

        <!-- Nivel y Capacidad -->
        <v-row class="mt-3">
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Nivel</div>
            <v-chip small :color="getLevelColor(clinic.level)">
              {{ getLevelLabel(clinic.level) }}
            </v-chip>
          </v-col>
          <v-col cols="6">
            <div class="subtitle-2 font-weight-bold grey--text">Inscripción</div>
            <div>{{ clinic.enrolled }}/{{ clinic.capacity }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- Estado de Inscripción -->
        <v-row class="mb-4">
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold grey--text mb-2">Estado de Inscripción</div>
            <v-progress-linear
              :value="(clinic.enrolled / clinic.capacity) * 100"
              height="8"
              class="mb-2"
              :color="getCapacityColor(clinic.enrolled, clinic.capacity)"
            ></v-progress-linear>
            <div class="caption">
              <span v-if="clinic.enrolled === clinic.capacity" class="red--text">
                ✓ Clínica llena
              </span>
              <span v-else class="orange--text">
                {{ clinic.capacity - clinic.enrolled }} lugar{{ clinic.capacity - clinic.enrolled > 1 ? 'es' : '' }} disponible{{ clinic.capacity - clinic.enrolled > 1 ? 's' : '' }}
              </span>
            </div>
          </v-col>
        </v-row>

        <!-- Descripción -->
        <v-row v-if="clinic.description">
          <v-col cols="12">
            <div class="subtitle-2 font-weight-bold grey--text">Descripción</div>
            <div class="pa-3 grey lighten-4 rounded">
              {{ clinic.description }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClinicDetailDialog',
  props: {
    dialog: Boolean,
    clinic: Object,
    teacherName: String
  },
  methods: {
    closeDialog () {
      this.$emit('update:dialog', false)
    },
    formatDate (dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('es-MX', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    getTypeColor (type) {
      const colors = {
        swing: 'blue',
        putting: 'green',
        pitch: 'orange',
        full_swing: 'purple',
        short_game: 'red'
      }
      return colors[type] || 'grey'
    },
    getTypeLabel (type) {
      const labels = {
        swing: 'Swing',
        putting: 'Putting',
        pitch: 'Pitch',
        full_swing: 'Swing Completo',
        short_game: 'Juego Corto'
      }
      return labels[type] || 'Otro'
    },
    getLevelColor (level) {
      const colors = {
        basico: 'green',
        intermedio: 'orange',
        avanzado: 'red'
      }
      return colors[level] || 'grey'
    },
    getLevelLabel (level) {
      const labels = {
        basico: 'Básico',
        intermedio: 'Intermedio',
        avanzado: 'Avanzado'
      }
      return labels[level] || 'Otro'
    },
    getCapacityColor (enrolled, capacity) {
      const percentage = (enrolled / capacity) * 100
      if (percentage >= 100) return 'red'
      if (percentage >= 75) return 'orange'
      return 'green'
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
